import Store from "@/store/index.js";
import axios from "axios";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
const domain = Store.state.domain;

export default {
  async obtenerDepartamento(vm) {
    var formData = new FormData();
    formData.append("tipoqueja", vm.datos.tipoQueja);
    axios
      .post(`${domain.domainNameForApi}Quejas/obtenerDepartamento`, formData)
      .then((response) => {
        vm.deptosArray = response.data;
      });
  },

  async obtenerFuenteQueja(vm) {
    axios.get(`${domain.domainNameForApi}Quejas/obtenerFuentes`).then((res) => {
      vm.fuentesArray = res.data;
    });
  },

  async obtenerConcepto(departamento, vm) {
    var formData = new FormData();
    formData.append("departamento", departamento);
    axios
      .post(`${domain.domainNameForApi}Quejas/obtenerConcepto`, formData)
      .then((response) => {
        vm.conceptosArray = response.data;
      });
  },

  async validarExisteReporte(vm) {
    var formData = new FormData();
    formData.append("nrreporte", vm.datos.nrreporte);
    formData.append("svindice", vm.datos.svindice); 
    let response = await axios.post(
      `${domain.domainNameForApi}Quejas/validarExisteReporte`,
      formData
    );
    return response.data;
  },

  async guardarQueja(vm) {
    var formData = new FormData();
    formData.append("quenombre", vm.datos.nombre);
    formData.append(
      "quecorreo",
      vm.datos.email == null || vm.datos.email == "" ? null : vm.datos.email
    );
    formData.append(
      "quetelefono",
      vm.datos.telefono2 == null || vm.datos.etelefono2mail == ""
        ? null
        : vm.datos.telefono2
    );
    formData.append(
      "nrreporte",
      vm.datos.nrreporte == null || vm.datos.nrreporte == ""
        ? null
        : vm.datos.nrreporte
    );
    formData.append(
      "svindice",
      vm.datos.svindice == null || vm.datos.svindice == ""
        ? null
        : vm.datos.svindice
    );
    formData.append("quetipoqueja", vm.datos.tipoQueja);
    formData.append("idDepartamento", vm.datos.departamento);
    formData.append("qjid", vm.datos.concepto);
    formData.append("quedescripcion", vm.datos.descripcion);
    formData.append(
      "folioex",
      vm.datos.folioex == null || vm.datos.folioex == ""
        ? null
        : vm.datos.folioex.trim()
    );
    formData.append("idFuente", vm.datos.idFuente);

    return axios
      .post(`${domain.domainNameForApi}Quejas/guardarQueja`, formData)
      .then((response) => response.data);
  },

  async obtenerListadoEstado(vm) {
    var formData = new FormData();
    axios
      .post(`${domain.domainNameForApi}Quejas/obtenerListadoEstado`, formData)
      .then((response) => {
        vm.estadoArray = response.data;
      });
  },

  async listadoDescargaExcel(vm) {
    var formData = new FormData();
    formData.append("datos", JSON.stringify(vm.datosBusqueda));

    return axios
      .post(
        `${domain.domainNameForApi}Quejas/PG_Quejas_ObtenerBusquedaReporteExcel`,
        formData
      )
      .then((response) => response.data);
  },

  async obtenerDetalleQueja(vm) {
    var formData = new FormData();
    formData.append("idQueja", vm.idQueja);
    return axios
      .post(`${domain.domainNameForApi}Quejas/ObtenerDetalleQueja`, formData)
      .then((response) => response.data);
  },

  async insertarMovimientoQueja(vm, tiposeg) {
    var formData = new FormData();
    formData.append("idQueja", vm.idQueja);
    formData.append("observaciones", vm.observaciones);
    formData.append("tipoSeg", tiposeg);

    return axios
      .post(
        `${domain.domainNameForApi}Quejas/insertarMovimientoQueja`,
        formData
      )
      .then((response) => response.data);
  },
};
